import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Bannertxt({ rtl }) {
  const className = rtl ? "experienced  p-100 rtl-style" : "experienced  p-100";
  return (
    <div className={className}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>شركة سعودية لتطوير تطبيقات الهاتف المحمول من الدرجة الأولى</h2>
            <p>
              باعتبارنا واحدة من أكثر شركات تصميم تطبيقات الأجهزة المحمولة
              ابتكارًا في جدة، فإننا ندرك كيف كانت المملكة العربية السعودية في
              الخطوط الأمامية لتطوير منتجات عالية التقنية، وبناء حلول مستدامة
              جاهزة للسوق وزيادة النمو الاقتصادي في المنطقة. لقد عززت تجربتنا في
              المملكة العربية السعودية كفاءاتنا ومكنتنا من مساعدة الشركات على
              التوسع باستخدام الحلول والاستشارات الرقمية المستدامة
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              هيا بنا نبدأ
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/sa/mobileapps.webp"
              alt="mobile app development company in dubai"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Bannertxt;
